import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@dc/ui-library/src/molecules/Tooltip/Tooltip';

function ProductListingResultsMessage(props) {
  return (
    <div className={'dc-product-listing__results-message'}>
      <div className={'dc-product-listing__products-count'}>
        <strong>
          <span>{props.showingResultsLabel}</span>
        </strong>
      </div>
      {props.productsPostXhrError &&
        (props.deviceType === 'wide' || props.deviceType === 'desktop') && (
        <Tooltip type={'warning'} radius>
          {'Sorry, we can\'t apply filters just now. Please try later.'}
        </Tooltip>
      )}
      {props.categoryProductCount === 0 &&
        (props.deviceType === 'wide' || props.deviceType === 'desktop') && (
        <Tooltip type={'warning'} radius>
          Please remove some of your filters
        </Tooltip>
      )}
    </div>
  );
}

ProductListingResultsMessage.displayName = 'ProductListingResultsMessage';

ProductListingResultsMessage.propTypes = {
  showingResultsLabel: PropTypes.string.isRequired,
  productsPostXhrError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  deviceType: PropTypes.oneOf(['wide', 'desktop', 'tablet', 'mobile']).isRequired,
  categoryProductCount: PropTypes.number.isRequired
};

ProductListingResultsMessage.defaultProps = {
  productsPostXhrError: null
};

export default ProductListingResultsMessage;
